export default __webpack_public_path__ + "static/eater-42658a15bdbe649df1e50d1fe0e33ffa.webp";